(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__faqAccordionBound) return;
    window.__faqAccordionBound = true;

    function setState(item, open) {
      var trigger = item.querySelector('[data-faq-trigger]');
      item.classList.toggle('faq-accordion__item--open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeOthers(root, keep) {
      root.querySelectorAll('[data-faq-item]').forEach(function (other) {
        if (other !== keep) setState(other, false);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger) return;
      var item = trigger.closest('[data-faq-item]');
      var root = trigger.closest('[data-faq]');
      if (!item || !root) return;
      var willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      if (willOpen) closeOthers(root, item);
      setState(item, willOpen);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target;
      if (!item || !item.hasAttribute || !item.hasAttribute('data-faq-item')) return;
      var root = item.closest('[data-faq]');
      if (root) closeOthers(root, item);
      setState(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
